// @flow
import SheetsRegistry from './SheetsRegistry'

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
const registry: SheetsRegistry = new SheetsRegistry()
export default registry
